import React from "react";
import "../css/PrivacyPolicy.css";

function MonetizationPolicy() {
  return (
    <div className="container-xxl p-0">
      <div className="policy-page">
        <div className="policy-header">
          <h1>Content Policy</h1>
          <h2>Bharat Jagriti</h2>
           <p>Effective Date: March 19, 2026 | Last Updated: April 11, 2026</p>
        </div>

        <div className="privacy-container">
          {/* 1. Introduction and Purpose */}
          <section>
            <h1 className="privacy-title">1. Introduction and Purpose</h1>
            <p>
              Bharat Jagriti is a platform where users share their views,
              knowledge and creativity. The monetization feature exists to
              reward creators who publish original, valuable content. This
              policy explains which posts qualify for monetization, which do
              not, and what happens when the rules are broken.
            </p>
          </section>

          {/* 2. Who This Policy Applies To */}
          <section>
            <h1>2. Who This Policy Applies To</h1>
            <p>
              This policy applies to every user who turns on monetization for a
              post. By enabling monetization, the user confirms that they have
              read this policy and agree to follow it.
            </p>
          </section>

          {/* 3. Core Eligibility Rule */}
          <section>
            <h1>3. Core Eligibility Rule</h1>
            <p>
              A monetized post is approved and paid only if it meets all three
              conditions below:
            </p>
            <ol>
              <li>The content is original and created by the user.</li>
              <li>
                The post falls under one of the eligible content categories in
                Section 5 and meets the format requirements in Section 6.
              </li>
              <li>
                The post contains nothing listed under &quot;Content Not
                Eligible for Monetization&quot; (Section 7) or &quot;Additional
                Prohibited Content&quot; (Section 9).
              </li>
            </ol>
            <p>
              A post that fails any of these conditions is not treated as a
              monetized post and is not paid.
            </p>
          </section>

          {/* 4. Recommended Content */}
          <section>
            <h1>4. Recommended Content (First Priority)</h1>
            <p>
              Political Content is the most preferred category on Bharat
              Jagriti. It includes:
            </p>
            <ul>
              <li>
                Opinions, analysis and commentary on politics and governance
              </li>
              <li>
                Information about, or review of, government schemes, policies
                and public decisions
              </li>
              <li>Awareness about social and national issues</li>
              <li>Lawful political content, as per the Constitution of India, including the right to expression, right to speech, right to freedom, and right to work and travel.</li>
            </ul>
            <p>
              Political content must be based on facts, must be free of abuse,
              violence and must not spread false and misleading information or
              hatred against any person, group or community.
            </p>
          </section>

          {/* 5. Eligible Content Categories */}
          <section>
            <h1>5. Eligible Content Categories</h1>
            <p>
              Apart from Political Content, the following categories are
              eligible for monetization, provided the content is original and
              meets Section 6:
            </p>
            <div className="table-responsive">
              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th>Category</th>
                    <th>What it includes</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Comedy</td>
                    <td>Clean, original humour</td>
                  </tr>
                  <tr>
                    <td>Informative Content</td>
                    <td>
                      Useful information, news-based analysis, tips and
                      explainers
                    </td>
                  </tr>
                  <tr>
                    <td>Educational Content</td>
                    <td>
                      Studies, career guidance, skill learning, exam
                      preparation
                    </td>
                  </tr>
                  <tr>
                    <td>Entertainment</td>
                    <td>Original entertainment content</td>
                  </tr>
                  <tr>
                    <td>Awareness-related Content</td>
                    <td>
                      Health, social, legal, financial and environmental
                      awareness
                    </td>
                  </tr>
                  <tr>
                    <td>Food Content</td>
                    <td>Original recipes, cooking tips and food reviews</td>
                  </tr>
                  <tr>
                    <td>Bhakti Content</td>
                    <td>
                      Bhajans, devotional and spiritual thoughts that respect
                      all faiths
                    </td>
                  </tr>
                  <tr>
                    <td>Other valid content</td>
                    <td>
                      Any other original, lawful content that follows this
                      policy
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>

          {/* 6. Format Requirements */}
          <section>
            <h1>6. Format Requirements</h1>
            <p>
              Monetization is meant for posts that carry real content, so the
              following format rules apply:
            </p>
            <ul>
              <li>
                Text-only posts are not eligible. A post made only of text
                cannot be monetized.
              </li>
              <li>
                A plain photo is not eligible. A normal photo, selfie or picture
                that carries no informative or creative content does not
                qualify, even if the user took it.
              </li>
              <li>
                Original video or original media with real content is eligible.
                A video or media post the user created themselves qualifies only
                if it clearly delivers value in an eligible category, such as an
                informative video, an educational explainer, a comedy skit, a
                food recipe or an awareness message.
              </li>
              <li>
                Value must be visible. The post should clearly inform, teach,
                entertain or raise awareness. A post that only shows a face, a
                place or an object without any such content is not eligible.
              </li>
            </ul>
          </section>

          {/* 7. Content Not Eligible for Monetization */}
          <section>
            <h1>7. Content Not Eligible for Monetization</h1>
            <p>
              If a monetized post contains any of the following, it is not
              eligible and will not be paid.
            </p>
            <ul>
              <h2>Photos</h2>
              <li>
                A normal photo of the user, or of anyone else, with no
                informative or creative content
              </li>
              <li>Any other plain or ordinary photo</li>
              <li>
                A screenshot taken of someone else&apos;s post, chat, profile or
                content
              </li>
              <li>A photo copied from another person</li>
              <li>A photo taken from another social media platform</li>
              <li>Any photo protected by copyright</li>
              <li>
                Monetized post should not have any advertisement of yours and others business or any other financial benefits.
              </li>
            </ul>
            <ul>
              <h2>Videos</h2>
              <p>The same rules apply to videos:</p>
              <li>
                A plain video of the user or of anyone else with no informative
                or creative content
              </li>
              <li>
                A screen recording or screenshot-based video of someone
                else&apos;s content
              </li>
              <li>A video copied from another person</li>
              <li>
                A video downloaded, re-uploaded or reposted from another social
                media platform
              </li>
              <li>
                Any video protected by copyright, including movie clips, songs,
                TV content and stock content used without a licence
              </li>
              <li>
                Monetized post should not have any advertisement of yours and others business or any other financial benefits.
              </li>
            </ul>
            <ul>
              <h2>Text</h2>
              <li>
                Posts that contain only text and no original photo or video
                content
              </li>
              <li>
                Monetized post should not have any advertisement of yours and others business or any other financial benefits.
              </li>
            </ul>
          </section>

          {/* 8. Consequences of a Violation */}
          <section>
            <h1>8. Consequences of a Violation</h1>
            <p>If any post is found to contain content from Section 7:</p>
            <ul>
              <li>The payment for that post will not be made.</li>
              <li>The post will not be counted as a monetized post.</li>
            </ul>
          </section>

          {/* 9. Additional Prohibited Content */}
          <section>
            <h1>9. Additional Prohibited Content</h1>
            <p>The following content is also not eligible for monetization:</p>
            <ul>
              <li>Fake news, false or misleading information</li>
              <li>
                Content that spreads hatred, incites violence or insults any
                religion, caste, gender, region or language
              </li>
              <li>
                Abuse, threats, bullying or content that defames a person
              </li>
              <li>Adult, obscene or sexual content</li>
              <li>
                Violation of privacy, such as sharing personal details or phone
                numbers without permission
              </li>
              <li>Content that promotes illegal or dangerous activities</li>
              <li>
                Spam, clickbait, repeating the same post again and again, or
                fake views, likes and followers
              </li>
              <li>
                Copying another person&apos;s text, article or post
                (plagiarism)
              </li>
              <li>Content that puts the safety of children at risk</li>
              <li>
                AI-generated or edited content that is misleading or made to
                look real without being clearly disclosed
              </li>
            </ul>
          </section>

          {/* 10. Special Rules for Political Content */}
          <section>
            <h1>10. Special Rules for Political Content</h1>
            <ul>
              <li>
                False information meant to influence voters or elections is not
                allowed.
              </li>
              <li>
                Supporting or opposing a party or leader is allowed, but it must
                rest on facts and stay respectful.
              </li>
              <li>
                Fake quotes or false statements attributed to any person are not
                allowed.
              </li>
              <li>
                Lawful political content, as per the Constitution of India, is allowed. This includes the right to expression, right to speech, right to freedom, and right to work and travel.
              </li>
              <li>
                Political content must still follow Sections 6, 7 and 9 like
                every other category.
              </li>
            </ul>
          </section>

          {/* 11. Review and Approval */}
          <section>
            <h1>11. Review and Approval</h1>
            <ul>
              <li>
                Monetized posts may be reviewed by the Bharat Jagriti team.
              </li>
              <li>After review, a post may be approved or rejected.</li>
               {/* <li>Bharat Jagriti deserves the right to reject the approval of monetized post on the basis of the quality of the content.If Bharat Jagriti feels that the content is not worth user engagement and is made only with the intention of earning money than that content is useless for us and we may reject the monetization approval of that post.</li> */}
              <li>
                Payment is made only for approved posts that comply with this
                policy.
              </li>
              <li>
                At the time of payment approval, we will review all monetized
                posts. Only those posts that are valid and comply with our
                Monetization Policy will be eligible for payment. If any
                monetized post does not comply with our policy, the monetization
                amount earned from that post will be counted as zero, and no
                payment will be made for it.
              </li>
              <li>
                Monetized post should not have any advertisement of yours and others business or any other financial benefits. If this is found during the review, the entire amount earned from that monetized post will be counted as zero.
              </li>
              <li>
                If the company is not satisfied with the content of your
                monetized post, that monetized post will not be considered
                valid. The earnings generated from that monetized post will be
                counted as zero, and the company may also block or delete that
                monetized post.
              </li>
              <li>
                Monetization will be only paid to our permanent users.
                Discotinued users monetization will be on hold.
              </li>
            </ul>
          </section>

          {/* 12. Action on Repeated Violations */}
          <section>
            <h1>12. Action on Repeated Violations</h1>
            <ul>
              <li>First violation: a warning, and no payment for that post.</li>
              <li>
                Repeated violations: the monetization feature may be suspended
                for some time or permanently.
              </li>
              <li>
                Serious or illegal violations: stricter action may be taken
                against the account.
              </li>
            </ul>
          </section>

          {/* 13. Complaints and Appeals */}
          <section>
            <h1>13. Complaints and Appeals</h1>
            <p>
              If a user believes a post was rejected by mistake, the user can
              request a review through app support. The Bharat Jagriti team will
              re-check the post and share the final decision.
            </p>
          </section>

          {/* 14. Changes to This Policy */}
          <section>
            <h1>14. Changes to This Policy</h1>
            <p>
              Bharat Jagriti may update this policy when needed. Changes apply
              once they are published in the app.
            </p>
          </section>

          {/* 15. User Consent */}
          <section>
            <h1>15. User Consent</h1>
            <p>
              By turning on monetization and clicking “I Agree”, the user confirms that they have read this policy and will follow it.
            </p>
          </section>

          {/* ================= हिंदी संस्करण (Hindi Version) ================= */}
          <hr />

          <section>
                <h1 className="privacy-title" style={{ textAlign: "center" }}>
            भारत जागृति - कंटेंट पॉलिसी
            </h1>
          </section>

          {/* 1. परिचय और उद्देश्य */}
          <section>
            <h1>1. परिचय और उद्देश्य</h1>
            <p>
              भारत जागृति एक ऐसा प्लेटफ़ॉर्म है जहाँ यूज़र अपने विचार, ज्ञान और
              रचनात्मकता साझा करते हैं। मोनेटाइज़ेशन फ़ीचर का उद्देश्य उन क्रिएटर्स
              को पुरस्कृत करना है जो मौलिक और मूल्यवान कंटेंट प्रकाशित करते हैं। यह
              पॉलिसी बताती है कि कौन-सी पोस्ट मोनेटाइज़ेशन के योग्य हैं, कौन-सी
              नहीं, और नियम तोड़े जाने पर क्या होता है।
            </p>
          </section>

          {/* 2. यह पॉलिसी किन पर लागू होती है */}
          <section>
            <h1>2. यह पॉलिसी किन पर लागू होती है</h1>
            <p>
              यह पॉलिसी हर उस यूज़र पर लागू होती है जो किसी पोस्ट के लिए
              मोनेटाइज़ेशन चालू करता है। मोनेटाइज़ेशन चालू करके, यूज़र पुष्टि करता
              है कि उसने यह पॉलिसी पढ़ ली है और इसका पालन करने के लिए सहमत है।
            </p>
          </section>

          {/* 3. मुख्य पात्रता नियम */}
          <section>
            <h1>3. मुख्य पात्रता नियम</h1>
            <p>
              किसी मोनेटाइज़ की गई पोस्ट को तभी स्वीकृत किया जाएगा और उसका भुगतान
              किया जाएगा जब वह नीचे दी गई तीनों शर्तें पूरी करती हो:
            </p>
            <ol>
              <li>कंटेंट मौलिक हो और यूज़र द्वारा स्वयं बनाया गया हो।</li>
              <li>
                पोस्ट धारा 5 में दी गई पात्र कंटेंट श्रेणियों में से किसी एक में
                आती हो और धारा 6 की फ़ॉर्मेट संबंधी आवश्यकताओं को पूरा करती हो।
              </li>
              <li>
                पोस्ट में &quot;मोनेटाइज़ेशन के लिए अपात्र कंटेंट&quot; (धारा 7) या
                &quot;अतिरिक्त प्रतिबंधित कंटेंट&quot; (धारा 9) के अंतर्गत
                सूचीबद्ध कुछ भी न हो।
              </li>
            </ol>
            <p>
              जो पोस्ट इनमें से किसी भी शर्त को पूरा नहीं करती, उसे मोनेटाइज़ की गई
              पोस्ट नहीं माना जाएगा और उसका भुगतान नहीं किया जाएगा।
            </p>
          </section>

          {/* 4. अनुशंसित कंटेंट */}
          <section>
            <h1>4. अनुशंसित कंटेंट (पहली प्राथमिकता)</h1>
            <p>
              राजनीतिक कंटेंट भारत जागृति पर सबसे अधिक पसंदीदा श्रेणी है। इसमें
              शामिल है:
            </p>
            <ul>
              <li>राजनीति और शासन पर विचार, विश्लेषण और टिप्पणी</li>
              <li>
                सरकारी योजनाओं, नीतियों और सार्वजनिक निर्णयों के बारे में जानकारी
                या उनकी समीक्षा
              </li>
              <li>सामाजिक और राष्ट्रीय मुद्दों के बारे में जागरूकता</li>
              <li>
                भारत के संविधान के अनुसार वैध राजनीतिक कंटेंट, जिसमें अभिव्यक्ति का
                अधिकार, बोलने का अधिकार, स्वतंत्रता का अधिकार, और काम करने तथा
                यात्रा करने का अधिकार शामिल हैं।
              </li>
            </ul>
            <p>
              राजनीतिक कंटेंट तथ्यों पर आधारित होना चाहिए, गाली-गलौज और हिंसा से
              मुक्त होना चाहिए, और किसी व्यक्ति, समूह या समुदाय के विरुद्ध झूठी और
              भ्रामक जानकारी या घृणा नहीं फैलानी चाहिए।
            </p>
          </section>

          {/* 5. पात्र कंटेंट श्रेणियाँ */}
          <section>
            <h1>5. पात्र कंटेंट श्रेणियाँ</h1>
            <p>
              राजनीतिक कंटेंट के अलावा, निम्नलिखित श्रेणियाँ मोनेटाइज़ेशन के लिए
              पात्र हैं, बशर्ते कंटेंट मौलिक हो और धारा 6 को पूरा करता हो:
            </p>
            <div className="table-responsive">
              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th>श्रेणी</th>
                    <th>इसमें क्या शामिल है</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>कॉमेडी</td>
                    <td>साफ़-सुथरा, मौलिक हास्य</td>
                  </tr>
                  <tr>
                    <td>सूचनात्मक कंटेंट</td>
                    <td>
                      उपयोगी जानकारी, समाचार-आधारित विश्लेषण, सुझाव और व्याख्याएँ
                    </td>
                  </tr>
                  <tr>
                    <td>शैक्षणिक कंटेंट</td>
                    <td>
                      पढ़ाई, करियर मार्गदर्शन, कौशल सीखना, परीक्षा की तैयारी
                    </td>
                  </tr>
                  <tr>
                    <td>मनोरंजन</td>
                    <td>मौलिक मनोरंजन कंटेंट</td>
                  </tr>
                  <tr>
                    <td>जागरूकता संबंधी कंटेंट</td>
                    <td>
                      स्वास्थ्य, सामाजिक, कानूनी, वित्तीय और पर्यावरणीय जागरूकता
                    </td>
                  </tr>
                  <tr>
                    <td>फ़ूड कंटेंट</td>
                    <td>मौलिक रेसिपी, कुकिंग टिप्स और खाने की समीक्षाएँ</td>
                  </tr>
                  <tr>
                    <td>भक्ति कंटेंट</td>
                    <td>
                      भजन, भक्ति और आध्यात्मिक विचार जो सभी धर्मों का सम्मान करते
                      हों
                    </td>
                  </tr>
                  <tr>
                    <td>अन्य वैध कंटेंट</td>
                    <td>
                      कोई भी अन्य मौलिक, वैध कंटेंट जो इस पॉलिसी का पालन करता हो
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>

          {/* 6. फ़ॉर्मेट संबंधी आवश्यकताएँ */}
          <section>
            <h1>6. फ़ॉर्मेट संबंधी आवश्यकताएँ</h1>
            <p>
              मोनेटाइज़ेशन उन पोस्ट के लिए है जिनमें वास्तविक कंटेंट हो, इसलिए
              निम्नलिखित फ़ॉर्मेट नियम लागू होते हैं:
            </p>
            <ul>
              <li>
                केवल टेक्स्ट वाली पोस्ट पात्र नहीं हैं। केवल टेक्स्ट से बनी पोस्ट को
                मोनेटाइज़ नहीं किया जा सकता।
              </li>
              <li>
                साधारण फ़ोटो पात्र नहीं है। कोई सामान्य फ़ोटो, सेल्फ़ी या तस्वीर जिसमें
                कोई जानकारीपूर्ण या रचनात्मक कंटेंट न हो, पात्र नहीं है, भले ही वह
                यूज़र ने खुद ली हो।
              </li>
              <li>
                मौलिक वीडियो या वास्तविक कंटेंट वाला मौलिक मीडिया पात्र है। यूज़र
                द्वारा स्वयं बनाई गई वीडियो या मीडिया पोस्ट तभी पात्र होती है जब वह
                किसी पात्र श्रेणी में स्पष्ट रूप से मूल्य प्रदान करती हो, जैसे कोई
                जानकारीपूर्ण वीडियो, शैक्षणिक व्याख्या, कॉमेडी स्किट, फ़ूड रेसिपी या
                जागरूकता संदेश।
              </li>
              <li>
                मूल्य स्पष्ट दिखना चाहिए। पोस्ट स्पष्ट रूप से जानकारी देनी चाहिए,
                सिखाना चाहिए, मनोरंजन करना चाहिए या जागरूकता बढ़ानी चाहिए। जो पोस्ट
                केवल चेहरा, कोई जगह या कोई वस्तु दिखाती है और ऐसा कोई कंटेंट नहीं देती,
                वह पात्र नहीं है।
              </li>
            </ul>
          </section>

          {/* 7. मोनेटाइज़ेशन के लिए अपात्र कंटेंट */}
          <section>
            <h1>7. मोनेटाइज़ेशन के लिए अपात्र कंटेंट</h1>
            <p>
              यदि किसी मोनेटाइज़ की गई पोस्ट में निम्नलिखित में से कुछ भी हो, तो वह
              पात्र नहीं है और उसका भुगतान नहीं किया जाएगा।
            </p>
            <ul>
              <h2>फ़ोटो</h2>
              <li>
                यूज़र की या किसी और की सामान्य फ़ोटो, जिसमें कोई जानकारीपूर्ण या
                रचनात्मक कंटेंट न हो
              </li>
              <li>कोई भी अन्य साधारण फ़ोटो</li>
              <li>
                किसी और की पोस्ट, चैट, प्रोफ़ाइल या कंटेंट का लिया गया स्क्रीनशॉट
              </li>
              <li>किसी अन्य व्यक्ति से कॉपी की गई फ़ोटो</li>
              <li>किसी अन्य सोशल मीडिया प्लेटफ़ॉर्म से ली गई फ़ोटो</li>
              <li>कॉपीराइट से सुरक्षित कोई भी फ़ोटो</li>
              <li>
                मोनेटाइज़ की गई पोस्ट में आपके या दूसरों के व्यवसाय का कोई विज्ञापन
                या कोई अन्य आर्थिक लाभ नहीं होना चाहिए।
              </li>
            </ul>
            <ul>
              <h2>वीडियो</h2>
              <p>यही नियम वीडियो पर भी लागू होते हैं:</p>
              <li>
                यूज़र या किसी और की साधारण वीडियो जिसमें कोई जानकारीपूर्ण या
                रचनात्मक कंटेंट न हो
              </li>
              <li>
                किसी और के कंटेंट की स्क्रीन रिकॉर्डिंग या स्क्रीनशॉट-आधारित वीडियो
              </li>
              <li>किसी अन्य व्यक्ति से कॉपी की गई वीडियो</li>
              <li>
                किसी अन्य सोशल मीडिया प्लेटफ़ॉर्म से डाउनलोड, री-अपलोड या दोबारा पोस्ट
                की गई वीडियो
              </li>
              <li>
                कॉपीराइट से सुरक्षित कोई भी वीडियो, जिसमें फ़िल्म क्लिप, गाने, टीवी
                कंटेंट और बिना लाइसेंस इस्तेमाल किया गया स्टॉक कंटेंट शामिल है
              </li>
              <li>
                मोनेटाइज़ की गई पोस्ट में आपके या दूसरों के व्यवसाय का कोई विज्ञापन
                या कोई अन्य आर्थिक लाभ नहीं होना चाहिए।
              </li>
            </ul>
            <ul>
              <h2>टेक्स्ट</h2>
              <li>
                ऐसी पोस्ट जिनमें केवल टेक्स्ट हो और कोई मौलिक फ़ोटो या वीडियो कंटेंट
                न हो।
              </li>
              <li>
                मोनेटाइज़ की गई पोस्ट में आपके या दूसरों के व्यवसाय का कोई विज्ञापन
                या कोई अन्य आर्थिक लाभ नहीं होना चाहिए।
              </li>
            </ul>
          </section>

          {/* 8. उल्लंघन के परिणाम */}
          <section>
            <h1>8. उल्लंघन के परिणाम</h1>
            <p>यदि किसी पोस्ट में धारा 7 का कोई कंटेंट पाया जाता है:</p>
            <ul>
              <li>उस पोस्ट का भुगतान नहीं किया जाएगा।</li>
              <li>उस पोस्ट को मोनेटाइज़ की गई पोस्ट नहीं माना जाएगा।</li>
            </ul>
          </section>

          {/* 9. अतिरिक्त प्रतिबंधित कंटेंट */}
          <section>
            <h1>9. अतिरिक्त प्रतिबंधित कंटेंट</h1>
            <p>निम्नलिखित कंटेंट भी मोनेटाइज़ेशन के लिए पात्र नहीं है:</p>
            <ul>
              <li>फ़र्जी खबरें, झूठी या भ्रामक जानकारी</li>
              <li>
                ऐसा कंटेंट जो घृणा फैलाता हो, हिंसा भड़काता हो या किसी धर्म, जाति,
                लिंग, क्षेत्र या भाषा का अपमान करता हो
              </li>
              <li>
                गाली-गलौज, धमकी, बुलिंग या किसी व्यक्ति को बदनाम करने वाला कंटेंट
              </li>
              <li>वयस्क, अश्लील या यौन कंटेंट</li>
              <li>
                गोपनीयता का उल्लंघन, जैसे बिना अनुमति के व्यक्तिगत जानकारी या फ़ोन
                नंबर साझा करना
              </li>
              <li>अवैध या खतरनाक गतिविधियों को बढ़ावा देने वाला कंटेंट</li>
              <li>
                स्पैम, क्लिकबेट, एक ही पोस्ट बार-बार दोहराना, या नकली व्यूज़, लाइक्स
                और फ़ॉलोअर्स
              </li>
              <li>
                किसी और का टेक्स्ट, लेख या पोस्ट कॉपी करना (साहित्यिक चोरी)
              </li>
              <li>ऐसा कंटेंट जो बच्चों की सुरक्षा को खतरे में डालता हो</li>
              <li>
                AI से बना या एडिट किया गया ऐसा कंटेंट जो भ्रामक हो या असली जैसा
                दिखाने के लिए बनाया गया हो और जिसे स्पष्ट रूप से बताया न गया हो।
              </li>
            </ul>
          </section>

          {/* 10. राजनीतिक कंटेंट के लिए विशेष नियम */}
          <section>
            <h1>10. राजनीतिक कंटेंट के लिए विशेष नियम</h1>
            <ul>
              <li>
                मतदाताओं या चुनावों को प्रभावित करने के उद्देश्य से दी गई झूठी
                जानकारी की अनुमति नहीं है।
              </li>
              <li>
                किसी पार्टी या नेता का समर्थन या विरोध करना अनुमत है, लेकिन वह
                तथ्यों पर आधारित होना चाहिए और सम्मानजनक रहना चाहिए।
              </li>
              <li>
                किसी भी व्यक्ति के नाम से फ़र्जी उद्धरण या झूठे बयान देने की अनुमति
                नहीं है।
              </li>
              <li>
                भारत के संविधान के अनुसार वैध राजनीतिक कंटेंट की अनुमति है। इसमें
                अभिव्यक्ति का अधिकार, बोलने का अधिकार, स्वतंत्रता का अधिकार, और काम
                करने तथा यात्रा करने का अधिकार शामिल हैं।
              </li>
              <li>
                राजनीतिक कंटेंट को भी हर अन्य श्रेणी की तरह धारा 6, 7 और 9 का पालन
                करना होगा।
              </li>
            </ul>
          </section>

          {/* 11. समीक्षा और स्वीकृति */}
          <section>
            <h1>11. समीक्षा और स्वीकृति</h1>
            <ul>
              <li>
                मोनेटाइज़ की गई पोस्ट की समीक्षा भारत जागृति की टीम कर सकती है।
              </li>
              <li>
                समीक्षा के बाद किसी पोस्ट को स्वीकृत या अस्वीकृत किया जा सकता है।
              </li>
               {/* <li>
                भारत जागृति को कंटेंट की गुणवत्ता के आधार पर किसी भी मोनेटाइज्ड पोस्ट की स्वीकृति को अस्वीकार करने का अधिकार है। यदि भारत जागृति को लगता है कि कंटेंट यूज़र एंगेजमेंट के योग्य नहीं है और केवल पैसे कमाने के उद्देश्य से बनाया गया है, तो ऐसा कंटेंट हमारे लिए उपयोगी नहीं है और हम उस पोस्ट के मोनेटाइजेशन की स्वीकृति को अस्वीकार कर सकते हैं।
              </li> */}
              <li>
                भुगतान केवल उन्हीं स्वीकृत पोस्ट का किया जाता है जो इस पॉलिसी का
                पालन करती हों।
              </li>
              <li>
                भुगतान स्वीकृति के समय, हम सभी मोनेटाइज़ की गई पोस्ट की समीक्षा
                करेंगे। केवल वही पोस्ट भुगतान के योग्य होंगी जो वैध हों और हमारी
                मोनेटाइज़ेशन पॉलिसी का पालन करती हों। यदि कोई मोनेटाइज़ की गई पोस्ट
                हमारी पॉलिसी का पालन नहीं करती, तो उस पोस्ट से अर्जित मोनेटाइज़ेशन
                राशि शून्य मानी जाएगी और उसके लिए कोई भुगतान नहीं किया जाएगा।
              </li>
              <li>
                मोनेटाइज़ की गई पोस्ट में आपके या दूसरों के व्यवसाय का कोई विज्ञापन
                या कोई अन्य आर्थिक लाभ नहीं होना चाहिए। यदि समीक्षा के दौरान ऐसा पाया
                जाता है, तो उस मोनेटाइज़ की गई पोस्ट से अर्जित पूरी राशि शून्य मानी
                जाएगी।
              </li>
              <li>
                यदि कंपनी आपकी मोनेटाइज़ की गई पोस्ट के कंटेंट से संतुष्ट नहीं है, तो
                वह मोनेटाइज़ की गई पोस्ट वैध नहीं मानी जाएगी। उस मोनेटाइज़ की गई पोस्ट
                से हुई कमाई शून्य मानी जाएगी, और कंपनी उस मोनेटाइज़ की गई पोस्ट को
                ब्लॉक या डिलीट भी कर सकती है।
              </li>
              <li>
                मोनेटाइज़ेशन का भुगतान केवल हमारे स्थायी यूज़र्स को ही किया जाएगा।
                बंद (डिस्कंटिन्यू) किए गए यूज़र्स का मोनेटाइज़ेशन रोक दिया जाएगा।
              </li>
            </ul>
          </section>

          {/* 12. बार-बार उल्लंघन पर कार्रवाई */}
          <section>
            <h1>12. बार-बार उल्लंघन पर कार्रवाई</h1>
            <ul>
              <li>पहला उल्लंघन: चेतावनी, और उस पोस्ट का कोई भुगतान नहीं।</li>
              <li>
                बार-बार उल्लंघन: मोनेटाइज़ेशन फ़ीचर कुछ समय के लिए या हमेशा के लिए
                निलंबित किया जा सकता है।
              </li>
              <li>
                गंभीर या अवैध उल्लंघन: खाते के विरुद्ध और सख्त कार्रवाई की जा सकती
                है।
              </li>
            </ul>
          </section>

          {/* 13. शिकायत और अपील */}
          <section>
            <h1>13. शिकायत और अपील</h1>
            <p>
              यदि किसी यूज़र को लगता है कि उसकी पोस्ट गलती से अस्वीकृत हुई है, तो
              वह ऐप सपोर्ट के माध्यम से समीक्षा का अनुरोध कर सकता है। भारत जागृति
              की टीम पोस्ट की दोबारा जाँच करेगी और अंतिम निर्णय साझा करेगी।
            </p>
          </section>

          {/* 14. इस पॉलिसी में बदलाव */}
          <section>
            <h1>14. इस पॉलिसी में बदलाव</h1>
            <p>
              भारत जागृति आवश्यकता पड़ने पर इस पॉलिसी को अपडेट कर सकता है। बदलाव
              ऐप में प्रकाशित होते ही लागू माने जाएँगे।
            </p>
          </section>

          {/* 15. यूज़र की सहमति */}
          <section>
            <h1>15. यूज़र की सहमति</h1>
            <p>
              मोनेटाइज़ेशन चालू करके और “I Agree” पर क्लिक करके, यूज़र पुष्टि करता
              है कि उसने यह पॉलिसी पढ़ ली है और इसका पालन करेगा।
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}

export default MonetizationPolicy;